

























































































































interface Suggestion {
    label: String;
    icon?: String;
    thumbnail?: String; // not yet supported
    disabled?: Boolean; // optional flag
    value?: any; // payload can be anything
}

import CoIcon from '../../Atoms/co-icon/CoIcon.vue';
import CoLabel from '../../Atoms/co-label/CoLabel.vue';
import CoDropdown from '../co-dropdown/CoDropdown.vue';
import CoDropdownItem from '../co-dropdown-item/CoDropdownItem.vue';

import axios from 'axios';
import { get, debounce } from 'lodash';
import { format } from 'date-fns';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';

export default {
    name: 'CoInput',
    components: {
        CoIcon,
        CoLabel,
        CoDropdown,
        CoDropdownItem,
        CoTippy,
        CoLoadingIndicator,
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Number, Boolean, null, undefined],
            default: null,
        },

        type: {
            type: String,
            default: 'text',
        },
        // used only for type number and date
        min: {
            type: [Number, String],
            default: 0,
        },
        max: {
            type: [Number, String],
            default: Number.MAX_SAFE_INTEGER,
        },
        // used only for type number
        step: {
            type: Number,
            default: 1,
        },
        placeholder: {
            type: String,
            default: '',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: '',
            required: false, // icon is optional
        },
        iconRight: {
            type: String,
            default: '',
            required: false, // icon is optional
        },
        width: {
            type: String,
            default: '100%',
        },
        background: {
            type: String,
            default: 'white',
            validator: (value) => ['white', 'transparent'].includes(value),
        },
        variant: {
            type: String,
            default: 'default',
        },
        validator: {
            type: Function,
            default: null,
        },
        noBorder: {
            type: Boolean,
            default: false,
        },
        noSpinButtons: {
            type: Boolean,
            default: false, // remove the spin buttons from the input
        },
        name: {
            type: String,
            default: null,
        },
        enterkeyhint: {
            type: String,
            default: 'send', // supported values https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint
        },
        suggester: {
            type: Function,
            default: null, // function must return a promise and return an Array of type Suggestions
        },
        resetonselect: {
            type: Boolean, // reset input value after selecting a suggestion
            default: false,
        },
        // validation
        required: {
            type: Boolean,
            default: false,
        },
        validationRegExp: {
            type: RegExp,
            default: null, // regular expression to validate input on client side
        },
        validationFunction: {
            // handler not yet implemented
            type: Function,
            default: null, // function must return a promise and return an Array of type Suggestions
        },
        validationHint: {
            type: String,
            default: null,
        },
        autocomplete: {
            type: String, // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
            default: null,
        },
        autofocus: {
            type: Boolean,
            default: false, // autofocus the input on mount
        },
        suggestionType: {
            type: String,
            default: null,
            validator: (value) => ['image', 'user', 'page', 'event', 'color', 'icon', null].includes(value),
        },
        textAlign: {
            type: String,
            default: 'left',
            validator: (value) => ['left', 'center', 'right'].includes(value),
        },
        styleOverrides: {
            type: Object,
            default: () => ({}),
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            content: this.value,
            windowWidth: 0,
            isMobile: false,
            activeSuggester: null,
            suggestionsLoading: false,
            suggestions: [],
            activeValidator: null,
            validationLoading: null,
            source: null,
            selectedItem: -1,
            passwordRevealed: false,
            validationError: null,
            // set input isValid = false by default if value is required
            isValid: this.required ? false : null,
            // custom debounce utility
            timer: null,
        };
    },
    computed: {
        inputValue() {
            return this.content;
        },
    },
    watch: {
        content(newVal) {
            // handle suggestions
            if (this.suggester) {
                this.handleSuggestions(newVal);
            }
            // handle validation with custom debounce because lodash debounce leads to canceling the input event of other CoInput instances
            this.customDebounce(() => this.inputValidation(newVal))();

            // emit input for data binding
            this.$emit('input', newVal);
        },
        value(newVal) {
            this.content = newVal;
        },
        validationError(newVal) {
            if (newVal === true) {
                this.isValid = false;
                this.$nextTick(() => {
                    this.$emit('validation-error', newVal);
                    this.$refs.tippyErrorMessage.show();
                });
            } else {
                if (newVal === false) this.isValid = true;
                this.$refs.tippyErrorMessage ? this.$refs.tippyErrorMessage.hide() : null;
            }
            //emit validation status change
            this.$emit('validationStatusUpdate', !newVal);
        },
    },
    mounted() {
        this.windowWidth = window.innerWidth;
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;

            if (this.windowWidth <= 992) {
                this.isMobile = true;
            } else {
                this.isMobile = false;
            }
        });
        this.$nextTick(() => {
            this.content = this.value;
            if (this.autofocus) {
                this.focus();
            }
        });
    },
    methods: {
        get,
        processValue(input) {
            let v = input;
            if (this.type === 'number') {
                if (v === '') {
                    return this.min;
                }

                // if v has any letter, remove it
                if (v.match(/[a-z]/i)) {
                    v = v.replace(/[a-z]/i, '');
                }

                // if v contains a comma, replace it with a dot
                if (v.includes(',')) {
                    v = v.replaceAll(',', '.');
                }
                // if v has more than one dot, remove all dots except the first one
                if (v.split('.').length > 2) {
                    v = v.replaceAll(/\.(?=.*\.)/g, '');
                }
                // if v has more than one minus, remove all minuses except the first one
                if (v.split('-').length > 2) {
                    v = v.replaceAll(/-(?=.*-)/g, '');
                }

                // if there space in the string, remove it
                if (v.includes(' ')) {
                    v = v.replaceAll(' ', '');
                }

                const numberV = parseFloat(v);

                if (numberV < this.min) {
                    return this.min;
                }

                if (numberV > this.max) {
                    return this.max;
                }

                const step = parseFloat(this.step);
                let rest = numberV % step;
                // round rest to step
                if (rest !== 0) {
                    rest = parseFloat(rest.toFixed(10));
                }
                // if step defined, round to step
                if (this.step && rest !== 0) {
                    if (this.step === 1) {
                        return Math.trunc(numberV);
                    }

                    const rounded = Math.round(numberV / step) * step;
                    return rounded;
                }

                return numberV;
            }
            if (this.type === 'date') {
                //  parse date to date format
                //  if min and max are defined, check if date is between min and max and return min or max if not

                if (this.min) {
                    const minDate = new Date(this.min);
                    const date = new Date(v);
                    if (date < minDate) {
                        const mindateasstring = format(minDate, 'yyyy-MM-dd');
                        return mindateasstring;
                    }
                }

                if (this.max) {
                    const maxDate = new Date(this.max);
                    const date = new Date(v);
                    if (date > maxDate) {
                        // convert max date to string in format yyyy-mm-dd
                        const maxdateasstring = format(maxDate, 'yyyy-MM-dd');
                        return maxdateasstring;
                    }
                }

                return v;
            }
            return v;
        },
        resetValue() {
            this.content = null;
        },
        handleInput(e) {
            if (!e.target.value) {
                this.$emit('input', undefined);
                return;
            }
            switch (this.type) {
                case 'number':
                    this.content = this.processValue(e.target.value);
                    break;
                default:
                    this.content = e.target.value;
            }
        },
        handleChange(e) {
            switch (this.type) {
                case 'number':
                    this.content = this.processValue(e.target.value);
                    break;
                default:
                    this.content = e.target.value;
            }

            this.$emit('change', this.content);
        },
        handleFocus(e) {
            this.$emit('focus');
        },
        handleEnter(e) {
            this.$emit('enter', this.content);
        },
        handleKeyDown(e) {
            // propagate the keydown event
            this.$emit('keydown', e);

            // handle the keydown event
            const key = get(e, 'key', '');
            switch (key) {
                case 'Enter':
                    this.suggestions?.length > 0
                        ? this.handleSelect(get(this.suggestions, `[${this.selectedItem}]`, []))
                        : null;
                    break;
                case 'ArrowDown':
                    if (this.selectedItem < this.suggestions.length - 1) {
                        this.selectedItem++;
                    } else {
                        this.selectedItem = 0;
                    }
                    break;
                case 'ArrowUp':
                    if (this.selectedItem > 0) {
                        this.selectedItem--;
                    } else {
                        this.selectedItem = this.suggestions.length - 1;
                    }
                    break;
                default:
                    break;
            }
        },
        handleBlur(e) {
            switch (this.type) {
                case 'number':
                    this.content = this.processValue(e.target.value);
                    break;
                case 'date':
                    this.content = this.processValue(e.target.value);
                    break;
                default:
                    this.content = e.target.value;
            }
            this.$emit('change', this.content);
            this.$emit('blur', this.content);
        },
        handleSuggestions(e) {
            //cancel previous suggester runs
            if (this.activeSuggester && this.activeSuggester.cancel) {
                this.activeSuggester.cancel();
            }
            // define debounced suggester
            this.activeSuggester = debounce(
                async function (e) {
                    if (!this.suggester || !e || e.length < 1) {
                        this.suggestions = [];
                        this.suggestionsLoading = false;
                        return;
                    }

                    // cancel previous suggester runs (the message parameter is optional)
                    this.source ? this.source.cancel('Operation canceled by the user.') : null;
                    this.source = axios.CancelToken.source();
                    //
                    this.suggestionsLoading = true;
                    try {
                        this.suggestions = await this.suggester(e, this.source);
                        this.$emit('suggestions', this.suggestions);
                        this.suggestionsLoading = false;
                    } catch (error) {
                        if (!axios.isCancel(error)) {
                            console.warn('error fetching suggestions', error);
                            this.suggestionsLoading = false;
                        }
                    }
                },
                750,
                { leading: true, trailing: true }
            );
            // run debounced suggester
            this.activeSuggester(e);
        },
        handleSelect(suggestion) {
            if (!suggestion || suggestion.length === 0) return;
            this.$emit('select', suggestion);

            this.selectedItem = -1;

            this.resetonselect ? (this.content = '') : (this.content = get(suggestion, 'label', ''));
        },
        focus() {
            this.$refs['coInputElem'].focus();
        },
        blur() {
            this.$refs['coInputElem'].blur();
        },
        clear() {
            this.content = '';
        },
        customDebounce(func, timeout = 300) {
            return (...args) => {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    func.apply(this, args);
                }, timeout);
            };
        },
        inputValidation(e) {
            if (this.validationRegExp instanceof RegExp) {
                if (!e || typeof e !== 'string' || e.length < 1) {
                    if (this.required) {
                        this.validationError = true;
                    } else {
                        this.validationError = false;
                    }
                    return;
                }

                if (e.match(this.validationRegExp)) {
                    //valid
                    this.validationError = false;
                } else {
                    //invalid
                    this.validationError = true;
                }
            } else if (this.validator) {
                // call the custom validator function
                if (!e && !this.required) {
                    this.validationError = false;
                    return;
                }

                if (this.validator(e)) {
                    this.validationError = false;
                } else {
                    this.validationError = true;
                }
            } else if (this.required) {
                if (!e || e.length < 1) {
                    this.validationError = true;
                } else {
                    this.validationError = false;
                }
            }
        },
    },
};
